<template>
  <v-container class="pt-0 pb-0 pl-0 pr-0">
  <v-card
    class="pt-1 pb-1"
    outlined
    dark
    :color = this.getBackGroundColor
  >
    <v-list-item two-line style="text-align: center;">
      <v-list-item-content>
        <v-list-item-title style="font-size: 40px;">
          {{title}}
        </v-list-item-title>
        <v-list-item-subtitle style="font-size: 14px; line-height: 21px; white-space: normal !important;">
          {{subTitle}}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon dark class="ml-4 mb-2" @click="open">
          <v-icon class="material-icons-outlined">info</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </v-card>
  <v-dialog v-model="dialog" persistent width="500" @keydown.esc="close">
    <v-card :outlined="true" :raised="true">
      <div style="display: flex;">
        <v-spacer/>
        <v-btn icon @click="close" class="mt-3 mr-3">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <v-card-title primary-title class="mb-2 pt-0" style="color: #041E42;">
         {{subTitle}}
      </v-card-title>

      <v-card-text class="body-1 pb-2" v-html="content" style="color: #041E42;">
        {{content}}
      </v-card-text>

      <v-card-actions class="pt-2 pr-6 pb-6">
        <v-spacer></v-spacer>
        <v-btn depressed color="primary darken-1" @click="close" class="text-none"
               style="width: 120px; height: 50px; font-size: 16px; font-weight: bold;">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </v-container>
</template>

<script>
  export default {
    name: "Card",
    props: {
      title: [String, Number],
      subTitle: [String, Number],
      content: String,
      backgroundColor: String
    },
    data() {
      return {
        dialog: false,
      }
    },
    computed: {
      getBackGroundColor() {
         if (this.backgroundColor) {
           return this.backgroundColor;
         }
         return "#0E2D58";
      }
    },
    methods: {
        open() {
            this.dialog = true;
        },
        close() {
            this.dialog = false;
        },
    }
  }
</script>

<style scoped>
</style>
